import React, {useCallback, useEffect, useMemo} from "react";
import {
    CountryCode,
    CountryCodeItem,
    RegistrationFields,
} from "../../../../containers/RegistrationLoginPage/types";
import {SINGLE_SELECT} from "../../../HTMLEntities/SelectV2/utils";
import {Field, useForm, useFormState} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import SelectV2 from "../../../HTMLEntities/SelectV2";

import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface CountryCodeInterface {
    configuration: CountryCode;
}

const CountryCodeField: React.FC<CountryCodeInterface> = ({
    configuration,
}: CountryCodeInterface) => {
    const {fieldName, values, editable, selectedValue} = configuration;

    const countryCodeObjectToString = useCallback((countryCodeObject: CountryCodeItem) => {
        return countryCodeObject ? `${countryCodeObject.label} (+${countryCodeObject.code})` : "";
    }, []);
    const countryCodeObjectToPlaceHolderText = useCallback((countryCodeObject: CountryCodeItem) => {
        return countryCodeObject
            ? `${countryCodeObject.abbreviation} (+${countryCodeObject.code})`
            : "";
    }, []);

    const form = useForm();
    const {values: formCurrentValues} = useFormState<RegistrationFields>({
        subscription: {values: true},
    });
    const countryCodeObj = formCurrentValues.countryCode;
    useEffect(() => {
        if (countryCodeObj?.id && countryCodeObj?.id !== 2) {
            form.change("userCity", undefined);
        }
    }, [countryCodeObj, form]);

    return useMemo(() => {
        return (
            <Field
                name={fieldName}
                validate={composeValidators(regRequiredValidate())}
                {...(selectedValue ? {initialValue: selectedValue} : {})}
            >
                {(props) => {
                    return (
                        <SelectV2
                            placeholder="ISD Code"
                            type={SINGLE_SELECT}
                            items={values ?? []}
                            selectedOption={selectedValue ? [selectedValue] : undefined}
                            itemToString={countryCodeObjectToString}
                            commonFieldStyle={{
                                mobile: {width: "43%"},
                                laptop: {width: "43%"},
                            }}
                            //initialValue={props?.input?.value ?? ""}
                            isFocused={props?.meta?.active ?? false}
                            isFilled={typeof props.input.value === "object"}
                            error={errorHandler(props?.meta)}
                            isTouched={props?.meta?.touched}
                            inputRFF={props.input}
                            //metaRFF={props.meta}
                            fullWidthSelectDropdown={true}
                            placeHolderItemToString={countryCodeObjectToPlaceHolderText}
                            withSearch={true}
                            isDisabled={!editable}
                        />
                    );
                }}
            </Field>
        );
    }, [
        values,
        selectedValue,
        countryCodeObjectToString,
        countryCodeObjectToPlaceHolderText,
        fieldName,
        editable,
    ]);
};
export default CountryCodeField;
